module.exports = __webpack_public_path__ + "static/media/Barbershop contract.a455fb17.pdf";